module.exports = __webpack_public_path__ + "87f822c3123ddd0a0c33272cd90b9dee.MP3";